export default __webpack_public_path__ + "static/media/lock_icon.4a98cfdf.svg";